import M from "moment";

export const formGroup = {
  indentNo: { value: "" },
  noProspek: { value: "" },
  kodeCabang: { value: "" },
  indentDate: { value: M(new Date()).format("DD-MM-YYYY") },
  customerName: { value: "", mandatory: true },
  memberID: { value: "" },
  customerKTPNumber: { value: "", mandatory: true },
  customerHpNumber: { value: "", mandatory: true },
  customerWaNumber: { value: "" ,mandatory: true},
  email: { value: "" },
  customerAddress: { value: "", mandatory: true },
  customerProvinceId: { value: null, mandatory: true },
  customerKabKotId: { value: null, mandatory: true },
  customerKecamatanId: { value: null, mandatory: true },
  customerKelurahanId: { value: null, mandatory: true },
  customerZipCode: { value: null, mandatory: true },
  variantCode: { value: null, mandatory: true },
  idWarna: { value: null, mandatory: true },
  paymentPlan: { value: null , mandatory: true},
  indentDeposit: { value: "N" },
  totalDepositAmount: { value: "" },
};

export async function printPDF(data) {
  try {
    const blobUrl = URL.createObjectURL(data);

    const printWindow = window.open("", "_blank");
    if (!printWindow) return;

    printWindow.document.write(`
          <html>
            <head>
              <title>Print PDF</title>
              <link rel="icon" type="image/x-icon" href="/iconnagamas.ico" />
              <style>
                html, body { margin: 0; padding: 0; height: 100%; overflow: hidden; }
                iframe { width: 100%; height: 100%; border: none; }
              </style>
            </head>
            <body>
              <iframe id="pdfFrame" src="${blobUrl}"></iframe>
              <script>
                const iframe = document.getElementById('pdfFrame');
                iframe.onload = function () {
                  setTimeout(() => {
                    iframe.contentWindow.focus();
                    iframe.contentWindow.print();
                  }, 500);
                };
              </script>
            </body>
          </html>
        `);

    printWindow.document.close();
  } catch (error) {
    console.error("Failed to load or print PDF Blob:", error);
  }
};